import { render, staticRenderFns } from "./HandSwitchLogs.vue?vue&type=template&id=2387a31d&scoped=true&"
import script from "./HandSwitchLogs.vue?vue&type=script&lang=js&"
export * from "./HandSwitchLogs.vue?vue&type=script&lang=js&"
import style0 from "./HandSwitchLogs.vue?vue&type=style&index=0&id=2387a31d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2387a31d",
  null
  
)

export default component.exports